import { render, staticRenderFns } from "./cariEkstre.vue?vue&type=template&id=1c937888&scoped=true&"
import script from "./cariEkstre.vue?vue&type=script&lang=js&"
export * from "./cariEkstre.vue?vue&type=script&lang=js&"
import style0 from "./cariEkstre.vue?vue&type=style&index=0&id=1c937888&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c937888",
  null
  
)

export default component.exports